
import Vue from "vue";
import { mapState } from "vuex";
import { format, zonedTimeToUtc } from "date-fns-tz";
import PaymentIntegrityPicker from "./components/PaymentIntegrityPicker";
import { currentTimeZone } from "@/helpers";
import { sendOfficeFollowUpInterface } from "@/interfaces/PaymentIntegrities.interfaces";

export default Vue.extend({
  name: "Tables",
  components: { PaymentIntegrityPicker },
  data: () => {
    return {
      headers: [
        { text: "First Name", value: "firstName" },
        { text: "Last Name", value: "lastName" },
        { text: "Location Name", value: "practiceName" },
        { text: "Shift Date", value: "startDate" },
        { text: "Payment Due", value: "paymentDue" },
        { text: "Due Yet", value: "dueYet" },
        { text: "Invoice Paid?", value: "payNowUsed" },
        { text: "Total Amount", value: "totalInvoiceAmt" },
        { text: "Notes", value: "notes" },
        { text: "Select Record", value: "selectRecord" }
      ],
      payNowUsed: false,
      filterByDay: null as null | string,
      dateSync: false
    };
  },
  computed: {
    ...mapState(["PaymentIntegrities"]),
    listPaymentIntegrities(): Array<sendOfficeFollowUpInterface> {
      let listDates = this.$store.state.PaymentIntegrities;
      listDates = this.filterByDay
        ? listDates.filter(item => item.startDate === this.filterByDay)
        : listDates;

      return this.payNowUsed
        ? listDates.filter(item => item.payNowUsed === 1)
        : listDates;
    }
  },
  methods: {
    formDate(date: string): string {
      return format(zonedTimeToUtc(date, currentTimeZone()), "MMMM do yyyy");
    },
    formatNotes(notes: string): string | null {
      return notes.length > 0 ? notes.replace(/\|/gi, "<br />") : null;
    },
    dueYet(days: number): string {
      let dueYetDays = "";
      if (days > 1) {
        dueYetDays = `<b class="green--text">Due in ${days} Days</b>`;
      } else if (days === 1) {
        dueYetDays = `<b class="green--text">Due in ${days} Day</b>`;
      } else if (days === 0) {
        dueYetDays = `<b class="amber--text text--accent-4">Due Today</b>`;
      } else if (days === -1) {
        dueYetDays = `<b class="amber--text text--accent-4">${Math.abs(
          days
        )} Day Overdue</b>`;
      } else if (days >= -3) {
        dueYetDays = `<b class="amber--text text--accent-4">${Math.abs(
          days
        )} Days Overdue</b>`;
      } else if (days < -3) {
        dueYetDays = `<b class="red--text">${Math.abs(days)} Days Overdue</b>`;
      }
      return dueYetDays;
    },
    filterByDate(date) {
      this.filterByDay = date;
    },
    namePayNowUsed(status: number) {
      switch (status) {
        case 0:
          return "Not Paid Yet";
        case 1:
          return "Pay Now";
        case 2:
          return "Other Payment type";
        default:
          break;
      }
    }
  },
  created() {
    let list = this.$store.state.PaymentIntegrities;
    if (list.length === 1) {
      this.$emit("next", list[0].id, this.dueYet(list[0].dueYet));
    }
  }
});
